import { ButtonLink, Grid } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { VaultList } from '../HomePage/VaultList';
import { useVaultsQuery } from '../../../api/vaults';
import { useHasRole } from '../../../api/access';

export function VaultsPage() {
  const { t } = useTranslation();
  const isAdmin = useHasRole('ADMIN');
  const vaultsQuery = useVaultsQuery();

  return (
    <MainLayout
      title={t('Earning vaults')}
      actions={
        isAdmin ? <ButtonLink to="/account/vaults/create">{t('Open vault')}</ButtonLink> : null
      }
    >
      <Grid size={12}>
        <VaultList
          vaults={vaultsQuery.data}
          isLoading={vaultsQuery.isPending}
          error={vaultsQuery.error}
          isSearchEnabled
        />
      </Grid>
    </MainLayout>
  );
}
